module.exports = __webpack_public_path__ + "img/heater.d08442ae.png";